<template>
	<div class="agreement-container">
		<!-- 直接渲染长文本，保留换行与格式 -->
		<div class="agreement-content" v-html="agreementText"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				agreementText: `
两双筷子隐私政策
【我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（<b>IMEI</b>/<b>android ID</b>/<b>DEVICE_ID</b>/<b>IDFA</b>、<b>SIM 卡 IMSI 信息</b>、<b>OAID</b>）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。详情内容请访问《[DCloud App引擎隐私政策](https://dcloud.io/license/appprivacy.html)》。】
【引言】
欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全可控。基于此，两双筷子服务提供者（或简称“我们”）制定本《两双筷子隐私政策》（下称“本政策”/“本隐私政策”），帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。
在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以<b>粗体红色</b>标识的<b>敏感个人信息</b>条款，确保您充分理解和同意之后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。
您同意隐私政策表示您已了解应用提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能、处理非必要个人信息，相关附加功能的开启、处理非必要个人信息以及处理<b>敏感个人信息</b>，我们会根据您的实际使用情况单独征求您的同意。
本隐私政策将帮助您了解以下内容：
一、适用范围
二、信息收集及使用
三、对外提供信息
四、您的权利
五、信息的存储
六、政策的更新
七、未成年人保护
八、联系我们
附录：相关定义
一、适用范围
本政策适用于两双筷子服务提供者以两双筷子网站、手机客户端、小程序以及相关开放平台以及随技术发展出现的新形态向您提供的各项产品和服务。我们及关联公司就其向您提供的产品或服务单独设有隐私政策的，则相应产品或服务适用相应隐私政策。
除本政策说明的相关信息收集使用活动外，本政策不适用于其他第三方向您提供的其他服务，其他服务适用其向您另行说明的个人信息收集使用规则。
二、信息收集及使用
在您使用我们的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：
1、 为实现向您提供我们产品或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品或服务；
2、 为实现向您提供我们产品或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，不会影响您使用我们的基本功能。
我们在此特别提醒您：我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，故基本/附加功能及对应收集使用的个人信息类型、范围会有所区别，请以具体的产品/服务功能为准。
我们会为您提供的各项具体功能场景包括：
（一）帮助您成为我们的会员及账户管理
我们基于两双筷子账户为您提供服务。为了创建两双筷子账户您需要至少向我们提供您的<b>手机号码</b>、您注册手机的<b>IMSI</b>、<b>IMEI</b>、<b>MEID</b>、<b>ESN</b>、门店名称、门店所属区域、<b>门店地址</b>及门店经营类型。您需主动向我们提供<b>身份信息</b>或企业相关信息，如果您拒绝提供上述信息，您将无法注册两双筷子账户并使用相关功能服务。您可以基于您的员工管理创建员工角色账号，员工角色账号属于您两双筷子账号体系的构成部分，在创建员工角色账号时，您还需要提供员工的<b>手机号</b>，您需确保员工对两双筷子获取其手机号用于账户创建及认证充分知情并完全同意。您确认，本政策关于账户的表述均包含您的员工角色账户。您确认基于账户管理、使用时所提供的信息均取得您员工的充分授权。
完善账号信息：您可以选择提供头像、姓名、性别、邮箱完善您的账户信息，以实现维护您的基本资料，您理解您所上传的前述信息将被我们收集。
实人认证：您可以根据认证要求提交相应的<b>身份证件信息</b>或者<b>面部识别特征</b>以完成实人认证。若您需使用账户增强保护功能，您还可以选择提交<b>面部识别特征</b>，开启扫脸登录。
授权登录：若您选择自登录，您需要向我们提供您的账号密码作为网络身份识别信息。若您选择授权使用第三方账号登录，我们可能经您单独同意后向第三方提供您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或第三方处直接登录。此外，我们可能会根据您的单独同意从第三方处获取您的第三方账户信息，并与您的两双筷子账户进行绑定，使您可在第三方处直接登录、使用我们的产品或服务。例如，若您选择授权以支付宝账号登录，我们将根据您的授权获取您共享的支付宝账号信息，包含支付宝登录名、昵称、头像、性别。我们将在您单独同意的授权范围内使用您的相关信息。
您理解对您提交的信息中涉及自然人身份或自然人活动情况的信息属于个人信息，包括您提交的自然人身份信息、联系信息、位置信息及其他信息。我们对您提交的信息中涉及个人信息部分遵照本隐私政策进行保护，对您提交的与您经营相关的营业执照、门店信息、经营数据等不属于个人信息的部分，将按照法律法规的规定及与您签署服务协议的相关约定执行。
（二）为您提供门店、商品或服务信息发布展示
为向您提供更契合您需求的页面展示和搜索结果，同时为了解产品适配性、识别运行环境，保障应用的正常运行；验证交易唯一性，管理订单的正常运行，防止恶意刷单、恶意登录的行为，我们会收集和使用您在访问或使用两双筷子网站或客户端时的<b>浏览、搜索记录</b>及订单信息。
在您使用我们服务过程中，为了解产品适配性、识别账号异常状态，我们可能会请求您提供或自动收集您的使用情况并储存为网络日志信息。
我们会结合依法收集的您的<b>设备信息</b>、服务日志信息向您提供更契合您需求的页面展示。
（三）帮助您完成交易
当您使用我们的服务进行交易时，我们会通过系统为您生成交易订单。在订单生成过程中,您需提供您的订单信息（包括服务员姓名、商品或服务信息、货款金额、收款人姓名及支付方式、操作记录、<b>收款账户信息</b>），您同意我们获取您手机设备的<b>IMEI</b>、<b>IMSI</b>，<b>MEID</b>、<b>ESN</b>、<b>ANDROID ID</b>， 通过日志系统查询设备相关信息（系统版本、软件版本、<b>MAC地址</b>、应用列表），用以识别运行环境，保障应用的正常运行；验证交易唯一性，管理订单的正常运行，识别是否为您设备进行的操作行为，防止恶意刷单、恶意登录的行为。
当您选择使用自配送服务时，您需同时提供<b>门店地址</b>、商品或服务信息、具体订单号、订单创建时间、支付的金额、<b>收货人姓名</b>、<b>收货人地址</b>、<b>收货人联系电话</b>，我们收集这些信息是为了帮助您匹配骑手，顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。基于完成配送之目的，我们会将上述信息提供给实际配送方，您对此表示同意并承诺已取得收货人的充分授权。
我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、便于您查询交易信息、提供客服与售后服务及其他我们明确告知的目的。
为便于您了解、查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。您可以通过“我的订单”查看和管理您的订单信息。
如果我们委托第三方协助您完成交易时，我们会将订单信息或您必要的个人信息共享给第三方，否则我们将无法帮助您完成相关交易。合作的第三方可能包括银行、第三方支付公司、第三方配送公司等，为完成订单的交付，基于某些业务的法律要求，可能会要求您完成实名认证，我们会提供信息协助您完成实名认证，具体请参见本政策三、对外提供信息部分。
（四）提供经营管理服务
我们将收集您的门店信息、品牌ID、门店ID、设备型号、<b>设备SN码</b>、<b>MAC地址</b>、<b>ANDROID ID</b>、系统版本号、设备网络状态、服务员姓名、您在第三方平台处的门店信息（门店名称、商户ID），以方便您使用门店交接、关账、排队取号、配置功能。
（五）提供员工管理服务
为了向您提供员工信息及员工权限角色管理，实现员工管理功能，您同意授权我们收集您的店铺信息（品牌ID、门店ID）、员工姓名、性别、<b>电话号码</b>、电子邮箱、员工角色及优惠权限，用以绑定和识别员工归属门店，对应岗位及岗位对应使用权限。您确认已获得员工的授权，有权授权我们收集前述员工信息。
（六）提供库存管理及报表
为了实现库存订货、采购、配送、报废、新建地址及其他管理的数据查询索引，我们将收集您的采购单据号、配送单号、支付金额、<b>所在区域地址</b>、指定收货人姓名、<b>联系电话</b>、<b>预存款金额</b>、盘点单号订单号。
（七）完成收单、收入数据统计
为完成收单服务，您选择与我们合作的金融机构、第三方支付公司为您提供支付服务，若您为自然人，我们将收集您的姓名、<b>手机号码</b>、电子邮箱、<b>身份证信息及正反面照片</b>、<b>银行卡号</b>、支付工具账户信息，若您为单位的，我们将收集您的营业执照、单位名称、注册时间、注册地址、营业地址、法定代表人姓名、<b>法定代表人身份证</b>、<b>法定代表人手机号</b>、单位联系人身份证照片、<b>联系人手机号</b>、电子邮箱、<b>银行账户信息</b>、支付工具账户信息、客服电话。我们会将您提供的前述信息与您选择的相应金融机构、第三方支付公司共享，具体请参见本政策三、对外提供信息部分。
如您指定由自然人代您收款的，您需要提供自然人的相关<b>身份信息</b>、<b>银行卡信息</b>和<b>手机号码</b>，以便完成账户的实名校验，您确认您指定自然人收款和提供自然人的相关信息已获得自然人的完全授权。
为使我们及时获悉并确认您的收款进度及状态，为您提供经营管理、售后与争议解决服务，您同意我们可自您所选择的交易对象或您选择的金融机构、第三方支付公司处收集与订单支付相关的信息，同时收集您在金融机构、第三方支付公司处生成的商户编号，将商户编号与您的门店ID进行关联，以为您提供收单技术支持。
我们将收集您的收款金额，收款账单笔数、收款账单类型，支付类型、商品销售类型，以帮助您完成收款及收入数据的统计。
（八）提供排队、预定服务
在您使用排队服务，您将通过两双筷子系统录入顾客的姓名、性别、<b>手机号</b>，两双筷子将依据您的委托对前述信息进行储存，您确认在向两双筷子提供这些个人信息之前，您已经取得合法的授权。
（九）提供会员管理系统服务
为向您提供会员管理系统服务，我们会收集您通过两双筷子系统录入的会员信息，包括会员姓名、性别、<b>手机号码</b>、生日、<b>储值金额</b>、支付渠道，并依据您的委托代表您向会员发送商业推广信息或推荐服务。您确认您提供的会员信息及对会员信息的使用已获得该会员的完全授权。
您的会员管理系统服务可能由口碑（上海）信息技术有限公司(以下简称“口碑”）为您提供，如您使用的是口碑会员管理系统，两双筷子通过接口连通的方式在两双筷子系统嵌入口碑会员管理系统服务，您的会员信息储存及处理将由口碑依据您的委托进行，基于向您提供订单服务、小程序订单管理服务，您同意两双筷子自口碑处获取您的会员信息并依据您的委托对会员信息进行处理，您确保您提供的会员信息及对会员信息的使用已获得该会员的完全授权。
（十）提供外卖开通管理系统服务
为向您提供外卖开通及外卖订单管理服务，我们将与外卖平台服务方共享您的两双筷子商户ID、门店名称信息，具体请参见本政策三、对外提供信息部分。
为向您提供订单管理及经营报表服务，您同意我们可至您合作的外卖平台服务方处收集您的外卖订单信息。
（十一）提供小程序开通管理服务
为向您提供小程序开通及小程序订单管理服务，我们将与小程序平台服务方共享您的营业执照、食品经营许可证、<b>法定代表人身份证</b>，您同意我们自小程序平台服务方处获取您的AppID，将AppID与您的门店ID进行关联，以为您提供小程序订单管理服务，具体请参见本政策三、对外提供信息部分。
（十二）客服及争议处理
当您与我们联系或提出争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的会员身份。
为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、<b>通信/通话记录</b>及相关内容（包括账户信息、门店信息、软硬件设备信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账户信息和订单信息。
为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。
（十三）为您提供安全保障
为履行保障电子商务交易安全的法定义务，提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入风险，更准确地识别违反法律法规或两双筷子相关协议、规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全SDK收集您的<b>设备信息</b>、服务日志信息，并可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息（其中，我们可能会在应用后台运行期间收集<b>MAC地址</b>、<b>IMEI</b>及其他设备标识符进行风险校验），来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
（十四）其它
1、您知悉并同意，为向您介绍服务，维护、改进我们的产品或服务质量，我们会收集您的崩溃日志、操作日志、员工操作日志、<b>设备信息</b>进行数据分析以提高我们的系统稳定性。我们可能通过App页面向您发送消息通知，或使用您的注册的<b>手机号</b>或您授权接受信息的其他手机号向您发送商业性信息短信、进行电话回访或邀请您参与服务、产品或功能有关的客户调研。我们努力提升您的使用体验。如果您不想接受我们给您发送的商业性信息，您可通过短信提示回复退订或我们提供的其他方式进行退订或关闭。如果您不希望接受电话回访或客户调研，您可电话中明确表示拒绝。
2、您应保证在使用两双筷子服务中所提供的一切数据信息均为真实，且经过合法途径获得，若你提供的信息中含有其他人的个人信息（如您的员工信息、会员信息、供应商信息以及商家后续使用新增功能时所提供的个人信息），在向两双筷子提供这些个人信息之前，您需确保您已经取得合法的授权，一旦您在使用我们服务的过程中提供此类信息，我们将认为该类信息均为您有权处理，不存在任何违反法律、法规或侵犯任何第三方合法权利的事由/瑕疵/场景。
3、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，或者我们主动从第三方处获取您的个人信息，均会事先征求您的同意。
4、若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及<b>敏感个人信息</b>的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、<b>敏感信息加密存储</b>、访问权限控制）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
5、如我们停止运营两双筷子产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。
（十五）应用后台、静默状态下个人信息处理说明
在您将本应用切换至后台或处于静默运行状态时，仅为保障业务必要功能，我们及接入的第三方 SDK 会在您已同意本隐私政策的前提下有限收集部分信息，不会在后台静默读取通讯录、短信、日历、位置、通话记录等非必要权限信息：
1、我方 APP 自身：仅在发生交易风控校验、异常崩溃日志上报场景下，按需收集设备标识符（IMEI、Android ID、OAID、MAC 地址等），用于账号安全、反刷单、故障排查；仅触发事件时收集，不会持续轮询采集。
2、DCloud uni‑app 引擎 SDK：后台仅在应用异常崩溃时上报设备标识、系统版本用于性能统计优化，无崩溃事件则不主动上报。
三、对外提供信息
（一）共享
我们不会与两双筷子服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
1、 履行法定义务所必需的共享：我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，共享您的个人信息。
2、 取得您同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
3、 为订立、履行您作为一方当事人的合同所必需的情况下的共享：您通过两双筷子平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易、配送及售后服务需求。
4、 与关联公司间共享：为便于我们与关联公司共同向您提供部分服务，<b>【基于两双筷子账户向您提供产品和服务，保护两双筷子关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。】</b>我们只会共享必要的个人信息，且受本政策中所声明目的的约束，如果我们共享您的<b>敏感个人信息</b>或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至<b>敏感个人信息</b>。请您更加谨慎地考虑并做出决定。
（二）委托处理
我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其将单独征得您的同意。
目前，我们委托的授权合作伙伴包括供应商、服务提供商和其他合作伙伴。我们将信息委托给支持我们业务的供应商、服务提供商和其他合作伙伴处理，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、提供客户服务、支付便利或进行学术研究和调查。
为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。我们会与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。
<br>
<h3>附录：第三方SDK及信息共享清单</h3>
<p>为实现业务功能，我们会委托下列第三方处理部分个人信息；我们仅向第三方提供实现目的所必需的信息，第三方不得将信息挪作他用。<b>本APP不具备定向推送、个性化推荐功能，不会基于用户行为做个性化内容推荐。</b></p>
<table border='1' cellpadding='6' cellspacing='0' style='width:100%;border‑collapse:collapse;'>
<tbody>
<tr>
<td><b>第三方主体</b></td>
<td><b>SDK/服务名称</b></td>
<td><b>收集/共享的个人信息</b></td>
<td><b>使用目的</b></td>
<td><b>第三方隐私政策链接</b></td>
</tr>
<tr>
<td>DCloud（数字天堂）</td>
<td>uni‑app引擎SDK</td>
<td>设备型号、系统版本、匿名设备标识符、应用信息、崩溃堆栈信息</td>
<td>统计分析、异常日志、应用稳定性保障</td>
<td>DCloud App引擎隐私政策</td>
</tr>
</tbody>
</table>
（三）转让
如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
（四）公开披露
我们仅会在以下情况下，公开披露您的个人信息：
1、 基于您的主动选择及其他单独同意的情况下，我们可能会公开披露您的个人信息；
2、 如果我们确定您出现违反法律法规或严重违反两双筷子相关协议及规则的情况，或为保护两双筷子用户或公众的人身财产安全免遭侵害，我们可能披露关于您的个人信息，包括相关违规行为以及两双筷子已对您采取的措施。
四、您的权利
您可以通过以下方式查阅和管理您的信息，我们会在符合法律法规要求的情形下响应您的请求：
（一）查阅、更正和补充
您有权通过登录掌上两双筷子APP，进入“我的”页面，点击用户头像即可进行账号与安全设置的方式查阅、更正和补充您的信息。
（二）删除
在以下情形中，您可以通过与我们官网列明的客服电话向我们提出删除个人信息的请求：
1、 如果我们处理个人信息的行为违反法律法规；
2、 如果我们收集、使用您的个人信息，却未征得您的明确同意；
3、 如果我们处理个人信息的行为严重违反了与您的约定；
4、 如果我们的处理目的已实现、无法实现或者为实现处理目的不再必要；
5、 如果我们停止提供产品或者服务，或者保存期限已届满。
6、 您希望删除您的个人信息的。
若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。
当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。
（三）改变授权范围
您可以通过以下方式改变或者撤回您授权我们收集和处理您的个人信息的范围：
1、 在“我的-隐私-系统权限”中管理App使用的系统权限授权。
2、 在“我的-点选头像-账号与安全”中管理刷脸登陆授权。
3、 在“我的-点选头像-账号与安全-支付宝”中管理支付宝绑定授权。
对于您无法直接通过上述方式设置的授权，您可以通过客服联系进行修改，但请注意，对于部分类型的个人信息，例如实现两双筷子基本功能所必须的信息或者我们履行法律法规规定的义务所必需的信息，我们可能无法响应您改变授权范围的请求。当您撤回授权后，我们将不再处理相应的个人信息。但您撤回授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。
（四）注销账户
您可以通过以下方式申请注销您的账户：
1、您可以自行在“注销账号”页面（我的-账号与安全-注销账号）提交账号注销申请；
在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除或匿名化处理您的个人信息。
（五）响应您的上述请求
对于您或可能的您的监护人、近亲属及其他有权主体向我们提出上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您可以通过客服联系我们或直接向我们的个人信息保护专职部门发起投诉。我们将在15天内做出答复。
为保障您的账户安全和您的个人信息安全，您向我们提出上述请求时，我们可能会先验证您的身份（如增加账户核验、要求您提供书面请求或其他合理方式），然后再处理您的请求。
对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
五、信息的存储
（一）存储期限
我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，我们会按照诉讼时效的法定要求对您的个人信息存储至少三年。
我们判断个人信息的存储期限主要依据以下标准：
1、 完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；
2、 保证我们为您提供服务的安全和质量；
3、 您是否同意更长的留存期间；
4、 是否存在关于保留期限的其他特别约定或法律法规规定。
5、保证我们在可能的诉讼案件中向法院进行举证；
在超出保留期间后，我们会根据适用法律的要求删除或匿名化处理您的个人信息。
（二）存储位置
我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行法律规定的义务后，向可能的境外实体提供您的个人信息：
1、 适用的法律有明确规定；
2、 获得您的单独同意；
3、 您作为一方当事人的跨境电子商务交易及其他类型合同订立和履行所必需的。
针对以上情形，我们会按照本政策依法保护您的个人信息安全。
（三）存储安全
1、数据保护技术措施
我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性，在您的浏览器与服务器之间交换数据时受 SSL协议加密保护，我们提供HTTPS协议安全浏览方式；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。目前，我们的重要信息系统已经通过网络安全等级保护的三级测评。
2、 数据保护管理组织措施
我们建立了行业内先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理及产品技术的维度提升个人信息的安全性。我们已经设置了个人信息保护专职部门。我们通过培训课程和考试，不断加强员工对于保护个人信息重要性的认识。
3、个人信息安全事件的响应
如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理必要的措施，以尽可能降低对您个人的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将以短信、电话、推送通知及其他合理渠道告知您，难以逐一告知的，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
4、账户安全风险的防范
在使用两双筷子服务时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。此外，您也可以通过我们的服务与第三方建立沟通、交流信息或分析内容。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，不轻信通过其他交易工具进行交易，以免信息被窃取甚至遭遇电信网络诈骗。
如您担心自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们的客服以便我们根据您的申请采取相应措施。
六、政策的更新
为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策以告知您具体的变化。但未经您明确同意，我们不会限制您按照本政策所享有的权利。我们会在掌上两双筷子APP上发布对本政策所做的任何变更。
对于重大变更，我们还会提供更为显著的通知（包括我们会通过两双筷子公示的方式进行通知或向您提供弹窗提示）。
本政策所指的重大变更包括但不限于：
1、 产品的业务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；
2、 业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；
3、 个人信息共享或公开披露的主要对象发生变化；
4、 用户个人信息权利及其行使方式发生重大变化；
5、 处理个人信息保护负责人的联络方式及投诉渠道发生变化时；
6、 个人信息保护影响评估报告表明产品存在对个人权益有重大影响时。
七、未成年人保护
我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。
八、联系我们
您可以通过以下方式与我们联系，我们将在15天内回复您的请求：
如您对本政策内容有任何疑问、意见或建议，您可通过联系邮箱mtx@maitianxiong.com与我们联系；如您有对于个人信息处理的相关疑问、投诉、您也可以通过mtx@maitianxiong.com联系我们的个人信息保护负责人。
如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。

【开发者信息】
开发者名称：【杭州麦田熊科技有限公司】
统一社会信用代码：【91330110MAK65DKU4R】
注册地址：【浙江省杭州市余杭区闲林街道联荣路1-65号5楼A区1853室】
联系电话：【19244029917】
联系邮箱：【mtx@maitianxiong.com】
如您对本隐私政策有任何疑问、意见或建议，可通过上述联系方式与我们联系沟通。
`,
			};
		},
		methods: {},
	};
</script>

<style>
	/* 去掉 scoped：v-html 注入的 <b> 不会带 data-v 属性，scoped 选择器匹配不到 */
	.agreement-container {
		padding: 20px;
		line-height: 1.6;
		font-size: 14px;
		color: #333;
	}

	.agreement-content {
		white-space: pre-wrap;
	}

	/* 去掉font-size放大，仅红色加粗 */
	.agreement-content b {
		color: #f53f3f;
		font-weight: 700;
	}
</style>